import React, { useEffect, useState } from "react";
import { Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import MaterialTypography from "../../components/MaterialTypography";
import { postData } from "../Utils/Baseurl";
import { useSnackbar } from "../../components/SnackbarProvider";
import DynamicTable from "../../components/Dynamictabel/Dynamictabel";

const StakeHolder = () => {
  const [task, setTask] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const currentUser = sessionStorage.getItem("currentUser");

  
    const userColumns = [
    { header: "PROJECT NAME", key: "project_name" },
    { header: "TASK NAME", key: "task_title" },
    { header: "TASK CODE", key: "task_code" },
    { header: "TEAM NAME", key: "teams" },
    { header: "MILESTONE", key: "milestone_name" },
    { header: "STATUS", key: "status" },
    { header: "ACTION", key: "action" },
  ];

  const handleView = (id, data) => {
    navigate("/stakeholder/view", { state: data });
  };

  useEffect(() => {
    fetchStackHolder();
  }, []);

  const fetchStackHolder = async () => {
    setIsLoading(true);
    const formdata = new FormData();
    formdata.append("user_id", currentUser);
    try {
      const data = await postData("api/getStakeHolders_v1/", formdata);

      if (data?.status) {
        setTask(data?.data);
      } else {
        setTask([]);
      }
    } catch (error) {
      let message = "An unexpected error occurred";
      if (error?.response?.data?.message) {
        message = error.response.data.message;
      } else if (error?.message) {
        message = error.message;
      }

      showSnackbar(message, "error");
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <DashboardLayout>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
        p={1}
        mb={2}
      >
        <Stack direction="column" spacing={0}>
          <MaterialTypography variant="h5" fontWeight="medium">
            Stake Holder
          </MaterialTypography>
          <MaterialTypography variant="caption" color="text">
            You can view the stakeholder list here.
          </MaterialTypography>
        </Stack>
      </Stack>
      {/* <SimpleTable
        columns={userColumns}
        data={task}
        actionVisibility={{
          showEdit: false,
          showView: true,
          showDelete: false,
        }}
        isLoading={isLoading}
        onView={handleView}
        edit={false}
        deleteAction={false}
      /> */}
      <DynamicTable
              columns={userColumns}
              data={task}
              onView={handleView}
              actionVisibility={{
                showEdit: false,
                showView: true,
                showDelete: false,
              }}
              isLoading={isLoading}
              edit={false}
              deleteAction={false}
              multipleaction={false}
              // onComment={onComment}
        />
    </DashboardLayout>
  );
};

export default StakeHolder;
